/**
 * Feature flags for the application.
 *
 * These are controlled via Vite environment variables.
 * Set VITE_STRIPE_ENABLED=true in your .env file to enable Stripe features.
 */

/**
 * Check if Stripe billing features are enabled.
 * Controls visibility of:
 * - MembershipSection (premium upgrade/manage)
 * - TicketsTab (rally tickets)
 */
export function isStripeEnabled(): boolean {
  return import.meta.env.VITE_STRIPE_ENABLED === 'true';
}
